<template>
  <div :class="wrapperClasses" class="e-overall chat-landing">
    <transition name="canvas">
      <div v-show="!offcanvasOpen" class="e-canvas">
        <div v-if="!userInfo || !userInfo.id" class="e-canvas__background" />

        <TheHeader />

        <div class="e-content">
          <TheSidebar />
          <div class="e-scroll-container">
            <VuePerfectScrollbar class="e-content__inner">
              <div class="e-content__scroll">
                <div
                  class="e-module e-module--limited e-module--left e-module--landing"
                >
                  <article
                    :class="{
                      'e-chat--offline': !chatIsOpen
                    }"
                    class="e-module__column"
                  >
                    <div class="e-module__icon chat-landing__icon">
                      <icon-chat viewBox="-20 -20 140 140" />
                    </div>
                    <div class="e-module__header">
                      <h2 class="e-module__title chat-landing__title">
                        Live-Chat
                      </h2>
                    </div>
                    <div class="e-module__content"></div>
                  </article>
                  <article
                    :class="{
                      'e-chat--offline': !chatIsOpen
                    }"
                    class="e-module__column"
                  >
                    <div class="e-module__content">
                      <div
                        class="chat-landing__landing-text"
                        v-html="chatText"
                      />
                      <table v-if="!chatIsOpen && upcomingChatEvents.length">
                        <tbody>
                          <tr
                            v-for="chatEvent in upcomingChatEvents"
                            :key="chatEvent.id"
                          >
                            <td valign="top">
                              {{
                                format(chatEvent.beginning, 'EEEEEE, dd.MM.')
                              }}
                              {{ format(chatEvent.beginning, 'HH:mm') }}-{{
                                format(chatEvent.end, 'HH:mm')
                              }}
                              Uhr | Thema: {{ chatEvent.subject }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <footer v-if="chatIsOpen" class="e-module__footer">
                      <div class="link">
                        <router-link
                            
                            :to="{ name: 'liveChat' }"
                            class="e-btn e-btn--tertiary"
                          >
                          zum Live-Chat
                        </router-link>
                      </div>
                    </footer>
                  </article>
                </div>
              </div>
            </VuePerfectScrollbar>
          </div>
        </div>
        <TheFooter />
      </div>
    </transition>

    <transition name="offcanvas">
      <TheOffcanvas v-show="offcanvasOpen" />
    </transition>

    <ChatIdleConfirm />
  </div>
</template>

<script>
import { format, parseISO } from 'date-fns'
import deLocale from 'date-fns/locale/de'

import { mapGetters } from 'vuex'

import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import TheFooter from 'molecules/TheFooter/TheFooter'
import TheHeader from 'molecules/TheHeader/TheHeader'
import TheSidebar from 'molecules/TheSidebar/TheSidebar'
import TheOffcanvas from 'molecules/TheOffcanvas/TheOffcanvas'
import ChatIdleConfirm from 'organisms/ChatIdleConfirm/ChatIdleConfirm'
import IconChat from 'assets/icons/chat-solid.svg'

export default {
  components: {
    IconChat,
    ChatIdleConfirm,
    TheFooter,
    TheHeader,
    TheSidebar,
    TheOffcanvas,
    VuePerfectScrollbar
  },

  data: () => ({
    currentInfoVisible: false,
    loading: false
  }),

  computed: {
    ...mapGetters([
      'chatIsOpen',
      'currentChatEvent',
      'userInfo',
      'offcanvasOpen',
      'upcomingChatEvents'
    ]),
    chatText() {
      return this.chatIsOpen
        ? window.landingTexts.chatOpen +
            '<br>Thema: ' +
            ` ${this.currentChatEvent.subject}`
        : window.landingTexts.chatClosed
    },
    wrapperClasses() {
      let classes = {
        'e-overall--loggedin': this.userInfo && this.userInfo.id
      }
      return classes
    }
  },

  methods: {
    format(date, token) {
      return format(parseISO(date), token, {
        locale: deLocale
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '_assets/ChatLanding';
</style>
